import { Banknote } from "lucide-react";
import { cn } from "@/lib/utils";

export const CashNotice = ({ className, testId = "cash-notice" }) => (
  <div
    data-testid={testId}
    className={cn(
      "flex items-start gap-3 rounded-2xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm",
      className
    )}
  >
    <Banknote className="h-5 w-5 shrink-0 text-amber-500 mt-0.5" />
    <p>
      <span className="font-bold">No online payments.</span> Membership is paid in cash only after approval.
    </p>
  </div>
);
